import Vue from "vue";
import axios from "axios";
import { Message } from "ant-design-vue";

//结果拦截
let cancelError = false;
axios.interceptors.response.use(
  function (response) {
    if (response) {
      switch (response.data.code) {
        case 0:
          return response.data;
        case 10302:
          var toHref = response.data.url;
          var fromHref = encodeURIComponent(window.location.href);
          if (process.env.NODE_ENV != "development") {
            window.location.href = `${toHref}?service=${fromHref}`;
          }
          break;
        case 3003:
          if (cancelError == false) {
            cancelError = true;
            Message.error("无权限访问");
          }
          break;
        default:
          Message.error(response.data.msg);
          return Promise.reject(response);
      }
    } else {
      Message.error(response.data.msg);
      return Promise.reject(response);
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

let token = "qqVAV092wlOwKhdmIrxNcPNUudHeLvurDIQohY66";
Vue.prototype.$post = function (url, params, spinBool, type) {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === "development") {
      axios.defaults.headers = {
        //本地环境header要携带token
        token: token,
      };
    }
    if (spinBool) {
      this.$store.commit("setSpinning", true);
    }
    axios
      .post(url, params, type)
      .then((res) => {
        this.$store.commit("setSpinning", false);
        resolve(res);
      })
      .catch((err) => {
        this.$store.commit("setSpinning", false);
        reject(err);
      });
  });
};

Vue.prototype.$get = function (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export default axios;
